import { render, staticRenderFns } from "./dashboard-tsk.vue?vue&type=template&id=66c8e31a"
import script from "./dashboard-tsk.vue?vue&type=script&lang=js"
export * from "./dashboard-tsk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports